import { render } from "./LayoutMock.vue?vue&type=template&id=89589906"
import script from "./LayoutMock.vue?vue&type=script&lang=js"
export * from "./LayoutMock.vue?vue&type=script&lang=js"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__